const deferredYT = $.Deferred();

window.onYouTubeIframeAPIReady = () => deferredYT.resolve(window.YT);

$.getScript('https://www.youtube.com/iframe_api');

// NOTE callback gets called with window.YT as the first argument
export default function getYouTubeApi(callback) {
  deferredYT.done(callback);
}
